import React, { FC } from 'react';

interface HtmlRenderProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'dangerouslySetInnerHTML'> {
  html: string;
  element?: React.ElementType;
}

const HtmlRender: FC<HtmlRenderProps> = ({ html, element: HtmlTag = 'div', ...rest }) => {
  return <HtmlTag dangerouslySetInnerHTML={{ __html: html }} {...rest} />;
};

export default HtmlRender;
